var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1098.2 238.8",
    style: {
      enableBackground: "new 0 0 1098.2 238.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#202020;}\r\n\t.st1{fill:#EB2A31;}\r\n\t.st2{fill:#666666;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000129179845505108368470000007927703304706546080_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,4.4h29.1c0,5.7,0,11.1-0.2,17.2c5.7-10.2,17.3-21.5,40.4-21.3c42.3,0.2,50.3,32.6,50.3,55.5v78.2h-31 V63.7c0-19.4-6.4-34.3-28.1-34.3c-22,0.2-29.5,14.9-29.5,33.1v71.6H256V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.5,39.4c-0.2-6.8-3.8-13.9-15.8-13.9c-10.4,0-15.4,6.6-15.4,13c0.2,8.3,9.7,12.8,22,16.3 c20.8,5.7,43.2,11.8,43.5,39.7c0.5,26.7-22,43.7-49.1,43.7c-20.1,0-47.3-10.4-49.6-41.8h31c1.2,13.9,13.2,16.8,19.1,16.8 c9.7,0,18-6.4,17.7-15.1c0-11.1-9.7-14.2-33.5-22.5c-17.5-5.4-31.7-15.1-31.9-33.8c0-25.5,21.5-41.3,46.5-41.3 c17.5,0,43.5,7.8,46.1,39L448.5,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.4,79.5c1.4,20.8,19.8,32.4,37.6,32.1c15.1,0,25.3-6.9,31.2-17.5H623c-6.1,14.4-15.4,25.3-26.2,32.6 c-10.9,7.5-23.9,11.5-37.1,11.3c-39.9,0-68.5-32.4-68.5-68.5c0-36.9,28.8-69.2,68.1-69.2c19.4,0,36.4,7.3,48.4,19.9 c15.8,16.3,21.7,36.6,19.1,59.3H522.4z M596.4,55.9c-1.2-12.3-14.2-29.5-36.9-29.3c-22.9,0-35.5,16.5-36.6,29.3H596.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.8,4.4h29.1c0,5.7,0,11.1-0.2,17.2c5.7-10.2,17.2-21.5,40.4-21.3c42.3,0.2,50.3,32.6,50.3,55.5v78.2h-31 V63.7c0-19.4-6.4-34.3-28.1-34.3c-22,0.2-29.5,14.9-29.5,33.1v71.6h-31V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M828.3,39.4c-0.2-6.8-3.8-13.9-15.8-13.9c-10.4,0-15.4,6.6-15.4,13c0.2,8.3,9.7,12.8,22,16.3 c20.8,5.7,43.2,11.8,43.5,39.7c0.5,26.7-22,43.7-49.2,43.7c-20.1,0-47.3-10.4-49.6-41.8h31c1.2,13.9,13.2,16.8,19.1,16.8 c9.7,0,18-6.4,17.7-15.1c0-11.1-9.7-14.2-33.5-22.5c-17.5-5.4-31.7-15.1-31.9-33.8c0-25.5,21.5-41.3,46.5-41.3 c17.5,0,43.5,7.8,46.1,39L828.3,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M991,134.1h-29v-17.2c-5.4,10.2-17,21.5-40.4,21.3C879,137.9,871,105.5,871,82.8V4.4h31V75 c0,19.1,6.4,34.3,28.4,34c22.2,0,29.8-14.7,29.8-33.1V4.4H991V134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1064,39.4c-0.2-6.8-3.8-13.9-15.8-13.9c-10.4,0-15.4,6.6-15.4,13c0.2,8.3,9.7,12.8,22,16.3 c20.8,5.7,43.2,11.8,43.5,39.7c0.5,26.7-22,43.7-49.2,43.7c-20.1,0-47.3-10.4-49.6-41.8h31c1.2,13.9,13.2,16.8,19.1,16.8 c9.7,0,18-6.4,17.7-15.1c0-11.1-9.7-14.2-33.6-22.5c-17.5-5.4-31.7-15.1-31.9-33.8c0-25.5,21.5-41.3,46.6-41.3 c17.5,0,43.5,7.8,46.1,39L1064,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,69.1c0.1,38.2-30.9,69.3-69.1,69.3S-0.1,107.6-0.2,69.3S30.7,0.1,68.9,0c15.4,0,30.3,5.1,42.5,14.5 c-6.3,7.7-11.1,16.3-14.5,25.6c-16-15.4-41.5-14.8-56.8,1.2s-14.8,41.5,1.2,56.8s41.5,14.8,56.8-1.2c6.9-7.2,10.8-16.6,11.1-26.5 v-1.3c-0.1-38.2,30.9-69.3,69.1-69.4s69.3,30.9,69.4,69.1s-30.9,69.3-69.1,69.4c-15.4,0-30.3-5.1-42.5-14.5 c6.3-7.7,11.1-16.3,14.5-25.6c16,15.3,41.5,14.8,56.8-1.3s14.8-41.5-1.3-56.8s-41.5-14.8-56.8,1.3c-7,7.3-11,17-11.1,27.1 L138.3,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.5,69c0,7.7-6.2,14-13.9,14c-7.7,0-14-6.2-14-13.9s6.2-14,13.9-14c0,0,0,0,0,0 C186.3,55.1,192.5,61.3,192.5,69L192.5,69"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 203.6,
    className: "st1",
    width: 247.6,
    height: 11.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M354.2,219.6c-7.3,12.6-18.9,19.2-33.3,19.2c-20,0-36.4-17.9-36.4-37.1c0-21.7,17.1-37.7,36.5-37.7 c13.6,0,26.4,6.2,33.7,19.8h-12.6c-5.4-6.3-11.8-10.1-20.2-10.1c-15.1,0-26.8,12.7-26.8,27.1c0,15.1,11.4,28.4,26.2,28.4 c7.5,0,14.2-2.9,20-9.5L354.2,219.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.6,237.5v-72h10.1v72H368.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.8,238.8c-15.2,0-28.7-12.9-28.7-28.1c0-16.4,12.9-28.6,29.5-28.6c14.9,0,28.9,11.7,28.7,28.8 C452.1,225.3,440,238.8,422.8,238.8z M423.1,191.3c-10.4,0.2-18.8,8.6-18.9,19.1c0,10.2,8.5,19.2,18.7,19.2 c10.6,0.1,19.2-8.5,19.2-19C442.2,200,433.7,191.4,423.1,191.3L423.1,191.3L423.1,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M505.2,237.5v-5.8H505c-2.6,4.6-8.8,7.2-15.9,7.2c-11.6,0-22.5-6.2-22.5-25.2v-30.1h10.1v29.3 c0,11.3,4.2,16.7,13.4,16.7s14.1-6.5,14.1-16.9v-29.1h10.1v53.9L505.2,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.1,237.5v-7.7H577c-4.2,5.8-11.2,9-19.1,9c-15.7,0-28-11.9-28-27.7c0-16.4,11.7-29,27.7-29 c7.3,0,14.2,2.6,18.6,8.1h0.2v-24.7h10.1v72H577.1z M558.4,191.3c-10.3,0-18.4,8.7-18.4,19.3c0,10.1,8.3,19,18.4,19 c10.3,0,18.6-8.3,18.8-18.6C577.1,200,569.8,191.3,558.4,191.3L558.4,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M666.1,184.1c0-6.5-4.2-10.4-10.1-10.4c-5.3,0.2-9.5,4.5-9.6,9.8c0,5.1,3.4,8,10.4,10.2 c15.6,5,21.3,10.8,21.3,23.3c0,13-9.3,21.8-22.1,21.8s-22-9.1-22.2-22.7h10.5c0.1,7.8,4.7,13,11.7,13s11.6-5.1,11.6-12.2 c0-5.3-2.3-8.6-10-11.2c-17.8-6-21.7-11.9-21.7-22.1c0.1-11,9.1-19.7,20-19.6c0,0,0.1,0,0.1,0c11.9,0,20.4,7.5,20.6,20 L666.1,184.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M721,238.8c-15.2,0-28.7-12.9-28.7-28.1c0-16.4,12.9-28.6,29.5-28.6c14.9,0,28.9,11.7,28.7,28.8 C750.3,225.3,738.3,238.8,721,238.8z M721.3,191.3c-10.4,0.2-18.8,8.6-18.9,19.1c0,10.2,8.5,19.2,18.7,19.2 c10.6,0.1,19.2-8.5,19.2-19C740.4,200,731.9,191.4,721.3,191.3L721.3,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M766,237.5v-72h10.1v72H766z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M832.8,237.5v-5.8h-0.2c-2.6,4.6-8.8,7.2-15.9,7.2c-11.6,0-22.5-6.2-22.5-25.2v-30.1h10.1v29.3 c0,11.3,4.2,16.7,13.4,16.7s14.1-6.5,14.1-16.9v-29.1H842v53.9L832.8,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M861.8,237.5v-44.7h-7.3v-9.2h7.3v-18.1H872v18.1h8.9v9.2H872v44.7H861.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M892.8,177.3v-11.9h10.1v11.9H892.8z M892.8,237.5v-53.9h10.1v53.9H892.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M947,238.8c-15.2,0-28.7-12.9-28.7-28.1c0-16.4,12.9-28.6,29.5-28.6c14.9,0,28.9,11.7,28.7,28.8 C976.3,225.3,964.2,238.8,947,238.8z M947.3,191.3c-10.4,0.2-18.8,8.6-18.9,19.1c0,10.2,8.5,19.2,18.7,19.2 c10.6,0.1,19.2-8.5,19.2-19C966.4,200,957.9,191.4,947.3,191.3L947.3,191.3L947.3,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1029.6,237.5v-29.4c0-11.4-4.5-16.7-13.4-16.7s-14.2,6.5-14.2,16.7v29.5h-10.2v-53.9h9.4v5.8h0.2 c4-5.2,9.5-7.2,15.8-7.2c12.9,0,22.5,8.2,22.5,23.1v32.3H1029.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1079,197.9c-0.5-3.9-2.7-6.5-6.9-6.5c-3.9,0-6.3,2.6-6.3,5.7c0,4.6,4.7,5.9,10,7.6 c7.6,2.3,14.6,6.9,14.6,16.9c0,10.4-7.6,17.2-18.1,17.2c-9.7,0-19.1-6.6-19.1-19.1h10.1c0.5,6.5,3.8,9.8,9.1,9.8 c4.7,0,7.8-3,7.8-7.4c0-3.7-2.8-6.1-9.2-8.2c-13.2-4.2-15.5-9.9-15.5-16c0-9.5,8.1-15.9,16.9-15.9s16.2,6.2,16.5,15.8L1079,197.9z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcsBlack);
export default __webpack_public_path__ + "static/media/ccs-black.e59550b5905080c696e5c423c866b8f4.svg";
export { ForwardRef as ReactComponent };